﻿import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RestService } from 'src/app/_services/rest.service';
import { AlertService } from 'src/app/_services';
import { Lista } from 'src/app/_models';


@Component({ templateUrl: 'detalle.component.html' })
export class DetalleComponent implements OnInit {

    id: number;

    lista: Lista;

    mercadoPago: boolean = false;

    error: boolean = false;

    constructor(private restService: RestService, private route: ActivatedRoute, private alertService: AlertService) {
        this.error= false;
        this.route.params.subscribe(params => {
            if (params['id']) {
                this.id = JSON.parse(params['id']);
                this.load();
            } else {
                this.error= true;
            }
        });
        this.restService.getParam('mercadolibre').subscribe(data => {
            this.mercadoPago = data.valor.toString().toUpperCase() === 'TRUE';
        });
    }


    ngOnInit() {
        this.error= false;
    }


    
    private load() {
        this.restService.get('/rest-api/user/lista/' + this.id).subscribe(
            data => {
            this.lista = data;
            if (!data)
                    this.error = true;
            }
        );
    }

    // private esMonetizada(): boolean {
    //     return this.mercadoPago && this.lista.monetizada;
    // }

    private link(): string {
        return document.location.href.toString().replace('/user/lista/'+this.id,'/elegir?nombre=' + this.lista.nombre + '&codigo=' + this.lista.codigo);
    }

    linkWS(): string {
        return 'https://wa.me/?text=' + encodeURIComponent(this.link());
    }

    /* To copy any Text */
    copyText() {
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.link();
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }

}
